import React from 'react';
import './Switch.css';

const Switch = ({ on }) => {
  const classes = ["switch", on ? "on " : ""].join(" ");
  return (
    <div className={classes}>
      <div className="switch-toggle" />
    </div>
  );
};

export default Switch;